'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = 'src/base-components/contact-us.js';
exports.ContactUs = ContactUs;
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _glamorous = require('glamorous');
var _glamorous2 = _interopRequireDefault(_glamorous);
var _omit = require('lodash/omit');
var _omit2 = _interopRequireDefault(_omit);
var _themes = require('@marmalade/themes');
var _contact = require('@marmalade/contact');
var _singleContactLink = require('./single-contact-link');
var _singleContactLink2 = _interopRequireDefault(_singleContactLink);
var _withHeaderTheme = require('../hocs/with-header-theme');
var _withHeaderTheme2 = _interopRequireDefault(_withHeaderTheme);
var _contactIcon = require('./contact-icon');
var _contactIcon2 = _interopRequireDefault(_contactIcon);
var _openingHours = require('../hooks/opening-hours');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
var headerStyle = _themes.componentThemes.header.headerStyle;
ContactUs.propTypes = {
  theme: _propTypes.object.isRequired,
  width: _propTypes.number.isRequired
};
function ContactUs(_ref) {
  var theme = _ref.theme,
    width = _ref.width,
    rest = _objectWithoutProperties(_ref, ['theme', 'width']);
  var tel = theme.telephone;
  var telLink = 'tel:' + tel.split(' ').join('');
  var noOpen = !theme.openingHours;
  var _useOpeningHours = (0, _openingHours.useOpeningHours)(),
    message = _useOpeningHours.message;
  if (noOpen) {
    return _react2.default.createElement(_singleContactLink2.default, Object.assign({
      theme: theme,
      width: width,
      icon: 'cordless',
      text: tel,
      href: telLink
    }, rest, {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 27
      },
      __self: this
    }));
  }
  return _react2.default.createElement(_glamorous2.default.Div, Object.assign({
    display: 'flex'
  }, (0, _omit2.default)(rest, ['dispatch']), {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 30
    },
    __self: this
  }), _react2.default.createElement('a', {
    href: telLink,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 31
    },
    __self: this
  }, _react2.default.createElement(_contactIcon2.default, {
    type: 'cordless',
    __source: {
      fileName: _jsxFileName,
      lineNumber: 32
    },
    __self: this
  })), width >= theme.breakpoint_sm && _react2.default.createElement(_glamorous2.default.Div, {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    __source: {
      fileName: _jsxFileName,
      lineNumber: 35
    },
    __self: this
  }, _react2.default.createElement(_glamorous2.default.P, {
    lineHeight: '1',
    margin: 0,
    fontWeight: theme.fontBold,
    fontSize: '1.8rem',
    __source: {
      fileName: _jsxFileName,
      lineNumber: 36
    },
    __self: this
  }, tel), _react2.default.createElement(_glamorous2.default.P, {
    lineHeight: '1',
    margin: 0,
    fontSize: '1.4rem',
    color: theme[headerStyle('colorSecondary')],
    __source: {
      fileName: _jsxFileName,
      lineNumber: 39
    },
    __self: this
  }, message)));
}
exports.default = (0, _withHeaderTheme2.default)(ContactUs);